(function() {
    var $jssor = $('#JS-photo-slider-detail');
    if ($jssor.length === 0)
        return;

    var options = {
        $AutoPlay: false,                                   //[Optional] Whether to auto play, to enable slideshow, this option must be set to true, default value is false
        $SlideDuration: 500,
        $ArrowKeyNavigation: true,                          //[Optional] Specifies default duration (swipe) for slide in milliseconds, default value is 500
        $LazyLoading: 1,

        $ArrowNavigatorOptions: {                           //[Optional] Options to specify and enable arrow navigator or not
            $Class: $JssorArrowNavigator$,                  //[Requried] Class to create arrow navigator instance
            $ChanceToShow: 2                                //[Required] 0 Never, 1 Mouse Over, 2 Always
        },

        $ThumbnailNavigatorOptions: {                       //[Optional] Options to specify and enable thumbnail navigator or not
            $Class: $JssorThumbnailNavigator$,              //[Required] Class to create thumbnail navigator instance
            $ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always

            $ActionMode: 1,                                 //[Optional] 0 None, 1 act by click, 2 act by mouse hover, 3 both, default value is 1
            $SpacingX: 15,                                   //[Optional] Horizontal space between each thumbnail in pixel, default value is 0
            $SpacingY: 12,                                   //[Optional] Vertical space between each thumbnail in pixel, default value is 0
            $DisplayPieces: 4,                              //[Optional] Number of pieces to display, default value is 1
        }
    };


    var jssor_slider1 = new $JssorSlider$('JS-photo-slider-detail', options);
    function ScaleSlider() {
        var parentWidth = jssor_slider1.$Elmt.parentNode.clientWidth;
        if (parentWidth)
            jssor_slider1.$ScaleWidth(Math.max(Math.min(parentWidth, 900), 200));
        else
            window.setTimeout(ScaleSlider, 30);
    }
    ScaleSlider();

    $(window).bind("load", ScaleSlider);
    $(window).bind("resize", ScaleSlider);
    $(window).bind("orientationchange", ScaleSlider);
}());
